import { render, staticRenderFns } from "./withdrawRuleSetting.vue?vue&type=template&id=286d2ed4&scoped=true&"
import script from "./withdrawRuleSetting.vue?vue&type=script&lang=js&"
export * from "./withdrawRuleSetting.vue?vue&type=script&lang=js&"
import style0 from "./withdrawRuleSetting.vue?vue&type=style&index=0&id=286d2ed4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286d2ed4",
  null
  
)

component.options.__file = "withdrawRuleSetting.vue"
export default component.exports